'use client';

import { useAppAdjustLink } from 'hooks';
import type { ButtonVariantProps } from '../types';
import { ButtonWithLinkMasking } from './ButtonWithLinkMasking';
import type { LinkNode } from 'data-layer';

export function ButtonWithAppDeepLinking(props: ButtonVariantProps) {
  const { link, creativeId } = props;
  const ctaAppAdjustLink = useAppAdjustLink(link?.url || '', creativeId);
  const deepLink: LinkNode = {
    ...(link as LinkNode),
    url: ctaAppAdjustLink || (link?.url as string),
  };

  return <ButtonWithLinkMasking {...props} link={deepLink} />;
}
